<template>
  <BrToolBar @search="buscar" :configFilter="configFilter" :addlFilter="addlFilter" :labelTextField="labelTextField" :divHidden="true" :isDisabledAll="true">

    <BrModalCadastro />
    
    <!-- <ModalTiposContratos /> -->

  </BrToolBar>
</template>

<script>
/**
 * MIXIN
 */
import toolbar from '@/views/mixins/toolbar'

export default {
  name: `BrToolBarCadastro`,
  mixins: [toolbar],
  components: { 
    BrModalCadastro: () => import('./modalCadastro'),
    // ModalTiposContratos: () => import('./modalTiposContratos'),
    BrToolBar: () => import('@/views/components/toolbar/newToolbar')
  }
}
</script>